import React, {useContext} from "react"
import UspSection from "../home/UspSection"
import BrandWorldLeadMagnets from "./components/BrandWorldLeadMagnets"
import BrandWorldInsurance from "./BrandWorldInsurance"
import GoogleReviews from "../googleReviews/GoogleReviews"
import Typography from "../reusable/Typography/Typography"
import LayoutContext from "../../context/LayoutContext"
import DataContext from "../../context/DataContext"
import BrandWorldContactUs from "./components/BrandWorldContactUs"

type Props = {
	reviews:any[]
}
function ResourcesSection({reviews}: Props) {
	const {brandWorld} = useContext(DataContext)
	const {isMobile} = useContext(LayoutContext)
	return (
		<section style={{
			zIndex: "1",
			marginTop: "60px"
		}}>
			<UspSection isBrandWorld/>
			<BrandWorldLeadMagnets />
			<div className="d-flex align-items-center flex-column mt-3 col-12 justify-content-center ">
				<Typography variant="bodyLgBlack"
					className="typography-amount "
					style={{textAlign: "center", marginBottom: isMobile ? "50%" : "34px", maxWidth: "1300px"}} >
					{brandWorld.insuranceTitle}
				</Typography>
				<BrandWorldInsurance />
			</div>
			<div style={{marginTop: "120px"}}
				className="d-flex align-items-center container justify-content-center flex-column">

				<BrandWorldContactUs />
				<GoogleReviews reviews={reviews} />
			</div>

		</section>
	)
}

export default ResourcesSection
